import { useState } from 'react'
import { useDebouncedState } from './useDebouncedState'

export interface PaginationProps {
  pageCount?: number
  handleFirstPage?: () => void
  handleLastPage?: () => void
  handleNextPage?: () => void
  handlePrevPage?: () => void
}

export const usePagination = ({
  pageCount,
  handleFirstPage,
  handleLastPage,
  handleNextPage,
  handlePrevPage,
}: PaginationProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [search, debouncedSearch, setSearch] = useDebouncedState<string>('', 300)

  const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value)
  }

  const onFirstPage = () => {
    setCurrentPage(1)
    if (handleFirstPage) handleFirstPage()
  }

  const onLastPage = () => {
    if (pageCount) setCurrentPage(pageCount)
    if (handleLastPage) handleLastPage()
  }

  const onNextPage = () => {
    setCurrentPage(currentPage + 1)
    if (handleNextPage) handleNextPage()
  }

  const onPreviousPage = () => {
    setCurrentPage(currentPage - 1)
    if (handlePrevPage) handlePrevPage()
  }

  const searchPage = (search: string) => {
    setCurrentPage(1)
    setSearch(search)
  }

  return {
    currentPage,
    search,
    onFirstPage,
    onLastPage,
    onNextPage,
    onPreviousPage,
    searchPage,
    onSearchInputChange,
    debouncedSearch,
  }
}
